export default [
    {   
        // 首选往生者称谓
        appellation: '先父',
        // 是否禁止名称写入
        nameHolder: false,
        // 首选输入提示
        placeholder: '请对应称谓填写姓名',
        // 对应关系
        relative: {
            // 是否可选对应关系
            selectHolder: false,
            // 对应关系
            appellation: '先母',
            // 对应关系输入提示
            placeholder: '请对应称谓填写姓名',
        },
        // 阳上提示信息
        placeholder2: '示例：子:XXX,子:XXX,女:XXX'
    },
    {   
        appellation: '先母',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先父',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：子:XXX,子:XXX,女:XXX'
    },

    {   
        appellation: '先祖父',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先祖母',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：孙:XXX,孙:XXX,孙女:XXX'
    },
    {   
        appellation: '先祖母',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先祖父',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：孙:XXX,孙:XXX,孙女:XXX'
    },

    {   
        appellation: '先外祖父',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先外祖母',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：外孙:XXX,外孙:XXX,外孙女:XXX'
    },
    {   
        appellation: '先外祖母',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先外祖父',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：外孙:XXX,外孙:XXX,外孙女:XXX'
    },

    {   
        appellation: '先公',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先婆',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：媳:XXX,媳:XXX,媳:XXX'
    },
    {   
        appellation: '先婆',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先公',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：媳:XXX,媳:XXX,媳:XXX'
    },

    {   
        appellation: '先岳父',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先岳母',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：婿:XXX,婿:XXX,婿:XXX'
    },
    {   
        appellation: '先岳母',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先岳父',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：婿:XXX,婿:XXX,婿:XXX'
    },

    {   
        appellation: '先伯父',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先伯母',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：侄:XXX,侄:XXX,侄女:XXX'
    },
    {   
        appellation: '先伯母',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先伯父',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：侄:XXX,侄:XXX,侄女:XXX'
    },

    {   
        appellation: '先叔',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先婶',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：侄:XXX,侄:XXX,侄女:XXX'
    },
    {   
        appellation: '先婶',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先叔',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：侄:XXX,侄:XXX,侄女:XXX'
    },

    {   
        appellation: '先舅父',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先舅母',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：外甥:XXX,外甥:XXX,外甥女:XXX'
    },
    {   
        appellation: '先舅母',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '先舅父',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：外甥:XXX,外甥:XXX,外甥女:XXX'
    },
    {
        appellation: '亡子',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡子(媳)',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：父:XXX,母:XXX'
    },
    {
        appellation: '亡子(媳)',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡子',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：父:XXX,母:XXX'
    },
    {
        appellation: '亡女',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡女(婿)',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：父:XXX,母:XXX'
    },
    {
        appellation: '亡女(婿)',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡女',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：父:XXX,母:XXX'
    },
    {
        appellation: '亡夫',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: true
        },
        placeholder2: '示例：妻:XXX'
    },
    {
        appellation: '亡妻',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: true
        },
        placeholder2: '示例：夫:XXX'
    },

    {   
        appellation: '亡兄',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡嫂',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：弟:XXX,弟:XXX,妹:XXX'
    },
    {   
        appellation: '亡嫂',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡兄',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：弟:XXX,弟:XXX,妹:XXX'
    },

    {   
        appellation: '亡弟',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡弟媳',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：兄:XXX,兄:XXX,姐:XXX'
    },
    {   
        appellation: '亡弟媳',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡弟',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：兄:XXX,兄:XXX,姐:XXX'
    },

    {   
        appellation: '亡姐',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡姐夫',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：弟:XXX,弟:XXX,妹:XXX'
    },
    {   
        appellation: '亡姐夫',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡姐',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：弟:XXX,弟:XXX,妹:XXX'
    },

    {   
        appellation: '亡妹',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡妹夫',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：兄:XXX,兄:XXX,姐:XXX'
    },
    {   
        appellation: '亡妹夫',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡妹',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：兄:XXX,兄:XXX,姐:XXX'
    },

    {   
        appellation: '亡友(男)',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡友妻',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },

    {   
        appellation: '亡友妻',
        hide: true,
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡友(男)',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },

    {   
        appellation: '亡友(女)',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡友夫',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },

    {   
        appellation: '亡友夫',
        hide: true,
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡友(女)',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },

    {   
        appellation: '亡人(男)',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡人妻',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },
    {   
        appellation: '亡人妻',
        hide: true,
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡人(男)',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },

    {   
        appellation: '亡人(女)',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡人夫',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },
    {   
        appellation: '亡人夫',
        hide: true,
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: false,
            appellation: '亡人(女)',
            placeholder: '请对应称谓填写姓名',
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },

    {   
        appellation: '某氏门中历代宗亲',
        nameHolder: false,
        placeholder: '请填写姓氏',
        relative: {
            selectHolder: true
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },

    {   
        appellation: '堕胎婴灵',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: true
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },
    {   
        appellation: '夭折婴灵',
        nameHolder: false,
        placeholder: '请对应称谓填写姓名',
        relative: {
            selectHolder: true
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },
    {   
        appellation: '普利十方',
        nameHolder: true,
        relative: {
            selectHolder: true
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },
    {   
        appellation: '冤亲债主',
        nameHolder: true,
        relative: {
            selectHolder: true
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },
    // {
    //     appellation: '历代先亡',
    //     nameHolder: true,
    //     relative: {
    //         selectHolder: true
    //     },
    //     placeholder2: '示例：XXX,XXX,XXX'
    // },
    {   
        appellation: '七世父母',
        nameHolder: true,
        relative: {
            selectHolder: true
        },
        placeholder2: '示例：XXX,XXX,XXX'
    },
    {   
        appellation: '爱宠',
        nameHolder: false,
        placeholder: '请填写姓氏',
        relative: {
            selectHolder: true
        },
        placeholder2: '示例：XXX,XXX,XXX'
    }
]